var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonChart',{attrs:{"data":_vm.processedData,"config":_vm.chartConfig,"xAxisUnit":_vm.getXAxisUnit,"container-class":"chart-container","height":"200px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }